import { render, staticRenderFns } from "./ArrowForward.vue?vue&type=template&id=b6b5e76a&scoped=true&"
import script from "./ArrowForward.vue?vue&type=script&lang=js&"
export * from "./ArrowForward.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6b5e76a",
  null
  
)

export default component.exports